import SdkPreview from '../SdkPreview';
import { TEMPLATE_MARKUP_ERROR } from './usePreviewRecommender';

// The layout on its own, in an isolated iframe, built by the SDK's own
// recommender path against real products — so a change to how a block is built
// on the shop shows up here without anything being kept in step by hand. It
// needs nothing from the customer's site to render: no framing permission, no
// SDK version, no page load.
const StandalonePreview = ({ recommender, scope }) => (
  <SdkPreview
    method="renderRecommender"
    payload={recommender}
    scope={scope}
    // The layout is compiled inside the frame now, so a template that will not
    // compile throws there; the wording the editor has always used for that
    // comes back with the reason from Handlebars in it.
    errorLabel={TEMPLATE_MARKUP_ERROR}
  />
);

export default StandalonePreview;
